import React from "react";

export const XCircleFilledIcon = (props) => {
  return (
    <svg
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y="0.818359" width="40" height="40" rx="20" fill="#18428E" />
      <g clipPath="url(#clip0_7074_205)">
        <path
          d="M17.0351 13.821C17.141 13.8211 17.2458 13.8429 17.343 13.8851C17.4402 13.9273 17.5276 13.989 17.6 14.0663L17.6588 14.1375L20.9661 18.6473L25.5671 14.0478C25.7064 13.909 25.8932 13.8284 26.0898 13.8224C26.2863 13.8164 26.4777 13.8854 26.6251 14.0155C26.7726 14.1455 26.8651 14.3268 26.8837 14.5225C26.9023 14.7182 26.8458 14.9137 26.7255 15.0692L26.6613 15.1419L21.8923 19.9102L26.7379 26.5185C26.8181 26.628 26.8682 26.7567 26.8829 26.8916C26.8977 27.0266 26.8767 27.1631 26.8221 27.2873C26.7674 27.4116 26.681 27.5193 26.5716 27.5996C26.4622 27.68 26.3335 27.7301 26.1986 27.745L26.1142 27.7496H22.8124C22.7064 27.7496 22.6016 27.7278 22.5045 27.6856C22.4073 27.6434 22.3198 27.5817 22.2475 27.5043L22.1887 27.4331L18.8799 22.9226L14.2804 27.5229C14.1411 27.6617 13.9542 27.7422 13.7577 27.7482C13.5612 27.7542 13.3698 27.6852 13.2223 27.5552C13.0749 27.4252 12.9824 27.2439 12.9638 27.0482C12.9451 26.8525 13.0017 26.657 13.122 26.5015L13.1862 26.4287L17.9536 21.6597L13.1096 15.0522C13.0293 14.9427 12.9793 14.814 12.9646 14.679C12.9498 14.5441 12.9708 14.4076 13.0254 14.2833C13.0801 14.1591 13.1665 14.0514 13.2759 13.971C13.3853 13.8907 13.514 13.8406 13.6489 13.8257L13.7333 13.821H17.0351Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_7074_205">
          <rect
            width="18.5714"
            height="18.5714"
            fill="white"
            transform="translate(10.6382 11.4995)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
